import { render, staticRenderFns } from "./FolderForm.vue?vue&type=template&id=2551191c"
import script from "./FolderForm.vue?vue&type=script&lang=js"
export * from "./FolderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports